import React, { useEffect, useState } from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import useToken from 'hooks/useToken';
import ErrorBoundary from 'components/common/ErrorBoundary';
import LinksPagosSeccion from './LinksPago/LinksPagosSeccion';
import SeccionArchivos from './SeccionArchivos';
import SeccionDatosFiscales from './seccion-datos-fiscales/SeccionDatosFiscales';
import SeccionDetallesOrden from './seccion-detalles-orden/SeccionDetallesOrden';
import SeccionPagos from './seccion-pagos/SeccionPagos';
import FeedCard from './comentarios/FeedCard';
import FeedProvider from './comentarios/FeedProvider';
import SeccionHeader from './seccion-header/SeccionHeader';
import OrdenCliente from './SeccionCliente';
import OrdenModalCancelar from './seccion-header/OrdenModalCancelar';
import useOrdenComentarios from './hooks/useOrdenComentarios';
import useOrdenNotificaciones from './hooks/useOrdenNotificaciones';
import useOrdenOperations from './hooks/useOrdenOperations';
import { useToast } from 'context/providers/ToastProvider';

const DetalleOrden = () => {
    const { id } = useParams();
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    const navigate = useNavigate();
    const { showErrorToast } = useToast();

    // Hooks personalizados
    const { procesandoComentario, submitComentario, guardarComentario } = useOrdenComentarios();
    const { crearObjAction, guardarNotificacion } = useOrdenNotificaciones();
    const { verificarPagosOrden, verificarLicenciasActivas } = useOrdenOperations();

    const [orden, setOrden] = useState({});
    const [ordenDetalles, setOrdenDetalles] = useState([]);
    const [linksPagos, setLinksPagos] = useState([]);
    const [numeroLinks, setNumeroLinks] = useState(0);
    const [comentarios, setComentarios] = useState([]);
    const [comentario, setComentario] = useState('');

    const [seleccionarFecha, setSeleccionarFecha] = useState(false);
    const [seleccionarFormaPago, setSeleccionarFormaPago] = useState(false);
    const [nuevaFormaPago, setNuevaFormaPago] = useState('');
    const [loadingInfoDetallesOrden, setLoadingInfoDetallesOrden] = useState(true);
    const [bPagoAntesOrden, setBPagoAntesOrden] = useState(0);

    const [showCancelarOrdenModal, setShowCancelarOrdenModal] = useState(false);
    const [motivoCancelacionOrden, setMotivoCancelacionOrden] = useState('');
    const [tienePagos, setTienePagos] = useState(false);

    // Obtener links de pago de la orden
    const ObtenerLinksPagoOrden = async () => {
        try {
            const response = await fetch(`/api/orden/ObtenerLinksPagoOrden?idOrden=${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                
                if (data.iResponseType === 1) {
                    const resultado = JSON.parse(data.detalles);
                    setLinksPagos(resultado.linksPagos || []);
                    setNumeroLinks(resultado.numeroLinks || 0);
                } else {
                    setLinksPagos([]);
                    setNumeroLinks(0);
                }
            } else {
                showErrorToast(`Error al obtener links de pago: ${response.status} ${response.statusText}`);
                
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Error al obtener links de pago: ' + error.message);
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
        }
    };

    // Obtener comentarios de la orden
    const ObtenerComentariosOrden = async () => {
        try {
            const response = await fetch(`/api/orden/ObtenerComentariosOrden?idOrden=${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                
                if (data.iResponseType === 1) {
                    const comentariosData = JSON.parse(data.detalles);
                    setComentarios(comentariosData);
                } else {
                    setComentarios([]);
                }
            } else {
                showErrorToast(`Error al obtener comentarios: ${response.status} ${response.statusText}`);
                
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Error al obtener comentarios: ' + error.message);
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
        }
    };

    // Obtener detalles de la orden
    const ObtenerDetallesOrden = async () => {
        setLoadingInfoDetallesOrden(true);

        try {
            const response = await fetch("/api/orden/ObtenerDetallesOrden/?id=" + id, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log("========== DETALLES DE ORDEN ==========");

                // 🆕 Procesar Table6 para obtener idLicencia vinculada (órdenes secundarias)
                let ordenConLicencia = { ...data["table1"][0] };
                if (data["table4"] && data["table4"].length > 0) {
                    ordenConLicencia.idLicenciaVinculada = data["table4"][0].idLicencia;
                    console.log("📋 Licencia vinculada detectada:", ordenConLicencia.idLicenciaVinculada);
                }

                setOrden(ordenConLicencia);
                setOrdenDetalles(data["table2"]);
                setBPagoAntesOrden(data["table3"][0].bPagoAntesOrden);
            } else {
                showErrorToast(response.status + ' ' + response.statusText);
              

                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('' + error.message);
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
        } finally {
            setLoadingInfoDetallesOrden(false);
        }
    };

    // Handler para enviar comentario
    const handleSubmitComment = async (e) => {
        e.preventDefault();

        if (!comentario) return;

        await submitComentario(
            id,
            comentario,
            orden,
            (comentarioBD) => {
                setComentarios(prevComentarios => [comentarioBD, ...prevComentarios]);

                // Enviar notificación
                const jsonData = JSON.stringify({ idOrden: comentarioBD.idOrden });
                const objToActionString = crearObjAction(2, "/ordenes/detalle/" + comentarioBD.idOrden, '', '');
                
                guardarNotificacion(
                    "Comentario en una orden",
                    `<strong>${nombreCompleto}</strong> hizo un comentario en la orden <strong>#${comentarioBD.idOrden}</strong> : <i>'${comentario.substring(0, 8)}...' </i>`,
                    0,
                    objToActionString,
                    6,
                    jsonData,
                    () => {},
                    (error) => {
                        showErrorToast(error);
                    }
                );

                setComentario('');
            }
        );
    };

    // Verificar si la orden tiene pagos
    const verificaSiOrdenTienePagos = async (action) => {
        await verificarPagosOrden(
            orden.idOrden,
            () => {
                // Editar
                if (action === 1) {
                    navigate("/ordenes/nueva/" + orden.idClienteAkasia + "/" + orden.idOrden);
                }
                // Cancelar
                if (action === 2) {
                    verificaSiTieneLicenciasActivas(1);
                }
            },
            (error) => {
                showErrorToast(error);
            }
        );
    };

    // Verificar si tiene licencias activas
    const verificaSiTieneLicenciasActivas = async (action) => {
        await verificarLicenciasActivas(
            orden.idOrden,
            () => {
                if (action === 1) {
                    setShowCancelarOrdenModal(true);
                }
            },
            (error) => {
                showErrorToast(error);
            }
        );
    };

    // Actualizar moneda de links de pago
    const actualizarMonedaLinksPagos = (nuevaMoneda) => {
        setLinksPagos(prevLinksPagos =>
            prevLinksPagos.map(linkPago => ({ ...linkPago, vMoneda: nuevaMoneda }))
        );
    };

    useEffect(() => {
        ObtenerDetallesOrden();
        ObtenerComentariosOrden();
        ObtenerLinksPagoOrden();
    }, [id]);

    return (
        <>
            <SeccionHeader
                loadingInfoDetallesOrden={loadingInfoDetallesOrden}
                orden={orden}
                setOrden={setOrden}
                loadingEdit={false}
                verificaSiOrdenTienePagos={verificaSiOrdenTienePagos}
               
                seleccionarFormaPago={seleccionarFormaPago}
                setSeleccionarFormaPago={setSeleccionarFormaPago}
                nuevaFormaPago={nuevaFormaPago}
                setNuevaFormaPago={setNuevaFormaPago}
                seleccionarFecha={seleccionarFecha}
                setSeleccionarFecha={setSeleccionarFecha}
              
                onComentarioAgregado={(comentario) => setComentarios(prev => [comentario, ...prev])}
            />
            {orden.dFechaPrimerPago < orden.dFechaVenta &&
                <Alert variant="danger">
                    <Alert.Heading>Oops! Tienes un error!</Alert.Heading>
                    <p>
                        La orden tiene fecha de {orden.dFechaVentaLarga}, el pago m&aacute;s antiguo registrado tiene fecha de {orden.dFechaPrimerPagoLarga}. Se puede observar que la orden tiene una fecha posterior al pago, esto no debe ocurrir, las fechas de las &oacute;rdenes deben ser siempre anteriores o el mismo d&iacute;a del primer pago. Edita la orden y selecciona la fecha del primer pago.
                    </p>
                </Alert>}
            {
                ((orden.vClave === "99" || orden.vClave === "28" || orden.vClave === "04" || orden.vClave === "31") && orden && linksPagos) &&
                <ErrorBoundary>
                    <LinksPagosSeccion
                        linksPagos={linksPagos}
                        setLinksPagos={setLinksPagos}
                        numeroLinks={numeroLinks}
                        orden={orden}
                        loadingInfoDetallesOrden={loadingInfoDetallesOrden}
                        GuardarComentario={guardarComentario}
                       
                    />
                </ErrorBoundary>
            }
            <Card className="mb-3">
                <ErrorBoundary>
                    <Card.Body>
                        <Row>
                            <OrdenCliente
                                loadingInfoDetallesOrden={loadingInfoDetallesOrden}
                                orden={orden}
                                bPagoAntesOrden={bPagoAntesOrden}
                                id={id}
                            />
                            <Col md={6} lg={4} className="mb-4 mb-lg-0">
                                <SeccionDatosFiscales
                                    loadingInfoDetallesOrden={loadingInfoDetallesOrden}
                                    orden={orden}
                                    setOrden={setOrden}
                                    GuardarComentario={guardarComentario}
                                    onComentarioAgregado={(comentario) => setComentarios(prev => [comentario, ...prev])}
                                />
                            </Col>
                            <Col md={6} lg={4}>
                                {!loadingInfoDetallesOrden &&
                                    <SeccionPagos
                                        orden={orden}
                                        setOrden={setOrden}
                                        idOrden={id}
                                        guardarNotificacion={guardarNotificacion}
                                        GuardarComentario={guardarComentario}
                                        crearObjAction={crearObjAction}
                                        onComentarioAgregado={(comentario) => setComentarios(prev => [comentario, ...prev])}
                                        setTienePagos={setTienePagos}
                                    />
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                </ErrorBoundary>
            </Card>
            <Card className="mb-3">
                <ErrorBoundary>
                    <SeccionDetallesOrden
                        loadingInfoDetallesOrden={loadingInfoDetallesOrden}
                        ordenDetalles={ordenDetalles}
                        orden={orden}
                        setOrden={setOrden}
                        GuardarComentario={guardarComentario}
                        ObtenerDetallesOrden={ObtenerDetallesOrden}
                        actualizarMonedaLinksPagos={actualizarMonedaLinksPagos}
                        onComentarioAgregado={(comentario) => setComentarios(prev => [comentario, ...prev])}
                        tienePagos={tienePagos}
                    />
                </ErrorBoundary>
            </Card>
            <Card className="mb-3">
                <ErrorBoundary>
                    <SeccionArchivos
                        idOrden={id}
                        GuardarComentario={guardarComentario}
                        orden={orden}
                        onComentarioAgregado={(comentario) => setComentarios(prev => [comentario, ...prev])}
                    />
                </ErrorBoundary>
            </Card>
            <FeedProvider>
                {!loadingInfoDetallesOrden &&
                    <ErrorBoundary>
                        <FeedCard
                            comentarios={comentarios}
                            procesandoComentario={procesandoComentario}
                            setComentario={setComentario}
                            comentario={comentario}
                            submitComment={handleSubmitComment}
                            idUsuario={Number(idUsuario)}
                            className='mb-3 mb-lg-0'
                        />
                    </ErrorBoundary>
                }
            </FeedProvider>
           
            <OrdenModalCancelar
                showCancelarOrdenModal={showCancelarOrdenModal}
                setShowCancelarOrdenModal={setShowCancelarOrdenModal}
                motivoCancelacionOrden={motivoCancelacionOrden}
                setMotivoCancelacionOrden={setMotivoCancelacionOrden}
                orden={orden}
                onOrdenCancelada={ObtenerDetallesOrden}
            />
        </>
    );
};

export default DetalleOrden;
